module.exports = __webpack_public_path__ + "img/profile-man-8-min.e62515df.jpg";